// extracted by mini-css-extract-plugin
export default {"table":"oGRe36XwYyV_9jBTI3sa","title":"oO8XjxqIBHXkf2vJlzen"};